import React from 'react';
import Link from 'components/commercetools-ui/atoms/link';
import { useFormat } from 'helpers/hooks/useFormat';
import WishlistIcon from 'icons/wishlist';
import { useWishlist } from 'frontastic';

const WishlistButton = () => {
  const { formatMessage: formatWishlistMessage } = useFormat({ name: 'wishlist' });
  const { data } = useWishlist();

  return (
    <Link
      link="/account/my-list"
      data-testid="header-wishlist-button"
      aria-label={`My List (${data?.lineItems?.length || 0}) - Go to your wishlist`}
      className="hidden cursor-pointer flex-col items-center justify-center text-center lg:flex"
    >
      <div className="mb-1 flex size-5">
        <WishlistIcon />
      </div>
      <span className="text-nowrap text-xs font-semibold">
        {formatWishlistMessage({ id: 'my.list', defaultMessage: 'My List' })} ({data?.lineItems?.length || 0})
      </span>
    </Link>
  );
};

export default WishlistButton;
